import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import type { RootState } from '../../../app/store';
import { Button } from '../../../app/components/AppButton';
import { IconArrowRight } from '../../../app/components/Icons';
import { paths } from '../../../app/routes/paths';
import mainBlockImage from '../../../assets/images/main-block.png';

const Main = (props: any) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const languageDefaultValue = useSelector(
    (state: RootState) => state.language.value,
  );

  useEffect(() => {
    i18n.changeLanguage(languageDefaultValue);
  }, [languageDefaultValue, i18n]);

  return (
    <section className="main-block">
      <div className="container-md main-block__inner">
        <div className="main-block__content">
          <h1 className="title">
            {t('main.hero.title.line1')} <br />
            {t('main.hero.title.line2')} <br />
            {t('main.hero.title.line3')}
          </h1>
          <p className="mt-36 mb-36">{t('main.hero.description')}</p>
          <div className="btn-group">
            <Button
              className="btn btn-primary w-200 mr-16 d-flex align-items-center position-relative"
              onClick={() => navigate(paths.signUp)}
              icon={<IconArrowRight isBlack />}
              iconPosition="right"
              title={t('main.hero.become_mentor')}
            />
          </div>
        </div>
        <div className="main-block__media">
          <img
            src={mainBlockImage}
            alt=""
            className="main-block__image"
          />
        </div>
      </div>
    </section>
  );
};

export default Main;
